import React, {useEffect} from 'react';
import AdminPageForm from "components/pageForm/admin.pageForm";
import AdminSubnav from "components/subNav/admin.subnav";
import CounterEquipe from "pages/admin/counterEquipe";
import TableAdmin from "components/table/tableAdmin";
import UseContext from "hooks/useContext";
import ApiDatabase from 'server'
import SubNavbar from "components/SubNavbar/SubNavbar";

const AdminCompany = () => {

    const {companyData, setStaffData, staffData, refreshStaff} = UseContext()

    useEffect(() => {
        if (Object.keys(companyData).length) {
            console.log('companyData.employees:', companyData.employees);
            console.log('companyData._id:', companyData._id);
            ApiDatabase.postStaffArray({staff: companyData.employees, id_company: companyData._id},
                (data) => {
                    console.log('API response staff:', data);
                    setStaffData(data)
                },
                (err) => {
                    console.log('Error fetching staff:', err)
                })
        }
    }, [companyData, refreshStaff])

    const titles = ['Membres', 'Rôle']

    return (
        <>
            <AdminPageForm>
                <SubNavbar>
                    <div className="w-full flex justify-end">
                        <AdminSubnav />
                    </div>
                </SubNavbar>

                <div className="w-full px-2 tab:px-4 lg:px-8 py-8 mb-28 flex flex-col gap-8">
                    <CounterEquipe />
                    <div className="w-full bg-white border border-gray-100 rounded-lg overflow-hidden">
                        <TableAdmin champsHeader={titles} champsBody={staffData || []}/>
                </div>
                </div>
            </AdminPageForm>
        </>
    );
};

export default AdminCompany;